module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-11.e10d3f85.png";